import React from "react";
import Modal from "./Modal";
import { SessionThemeWrapper } from "../contexts/SessionThemeContext";

function CrisisModal({_open, _onClose, _children, handleRejectWarning, isInCrisis = false}) {

  const warningMessage = isInCrisis
    ? "You are cared for and important. During difficult times like this, you deserve to work with a caring professional who can provide personalized support and human connection. Please reach out to your mental health provider or use the crisis resources below."
    : "We want you to have the best possible support. While our sessions can be helpful, you deserve personalized care from a professional who can interact with you directly. This isn't about you being 'too much' — it's about us wanting what's truly best for you. Please consider reaching out to your mental health provider or the crisis resources below.";

  const renderWarningContent = () => (
    <SessionThemeWrapper>
      <div className="fixed inset-0 flex items-center justify-center bg-black/60 p-4">
        <div className="bg-session-bg-elevated text-session-text rounded-lg shadow-lg p-6 max-w-md mx-auto">
          <div className="bg-session-bg border-l-4 border-session-accent p-4 mb-4 rounded">
            <p className="text-session-text mb-2 text-center font-semibold">You Are Important</p>
            <p className="text-session-text text-sm mb-2">
              <strong>You are cared for. You are loved. You deserve support.</strong>
            </p>
          </div>
          <p className="text-session-text text-sm mb-4">{warningMessage}</p>
          <div className="flex gap-2">
            {!isInCrisis && (
              <button
                onClick={() => handleRejectWarning(true)}
                className="bg-session-bg text-session-text border border-session-text-secondary/20 font-semibold py-2 px-4 rounded hover:bg-session-bg/70 transition text-sm"
              >
                Continue Session
              </button>
            )}
            <button
              onClick={() => handleRejectWarning(false)}
              className="bg-session-accent text-session-bg font-semibold py-2 px-4 rounded hover:opacity-90 transition text-sm"
            >
              Get Support Resources
            </button>
          </div>
        </div>
      </div>
    </SessionThemeWrapper>
  );

  return <Modal open onClose>{renderWarningContent()}</Modal>;
}

export default CrisisModal;
